(async () => {
    const { Core } = await importModule('Core');

    customElements.define('collection-modal-filters', class extends Core {

        subscriptions = {
            'collection:updated': '_onCollectionChange',
        }

        render() {
            this.subscribe('collection:updated');
        }
        _onCollectionChange({ doc }) {
            const template = doc.querySelector(this.getAttribute('target'));
            if (!template || !template.content) return;
            const fresh = template.content.querySelector(`${this.tagName}[section-id=${this.sectionId}]`);
            if (!fresh) return;

            const currentBrandsCat = this.querySelector('#mp-brands-category-block');
            const freshBrandsCat = fresh.querySelector('#mp-brands-category-block');
            const preservedBrandsCat = (currentBrandsCat && !freshBrandsCat)
                ? currentBrandsCat.cloneNode(true)
                : null;

            this.replaceChildren(...fresh.cloneNode(true).childNodes);

            if (preservedBrandsCat) {
                const firstNativeFilter = this.querySelector(':scope > collection-filter');
                if (firstNativeFilter) {
                    firstNativeFilter.insertAdjacentElement('afterend', preservedBrandsCat);
                } else {
                    this.appendChild(preservedBrandsCat);
                }
            }
        }
    })
})();